import React, { useState, useEffect, useContext } from 'react';
import { Icon } from '@mui/material';
import { getInfoChat } from '../../api/chatbotAPI';
import WrapperModal from '../ui/WrapperModal';
import VisualizerModal from './VisualizerModal';
import Loader from '../ui/Loader';
import { socket } from '../chatDashboard/SocketConnection';
import { ChatIdContext } from '../../store/chat-id-context';

const NotificationChat = ({
    data
})=>{
    const {chatId, setChatId} = useContext(ChatIdContext)
    const [visualizerModal, setVisualizerModal] = useState(false)
    const [infoModal, setInfoModal] = useState()
    const cancelCreationHandler = () =>{
		setVisualizerModal(false)
	}
    return(
        <div className='dashboard-general-wrapper'> 
            <div className='dashboard-content-container'>
                <div>
                <table className="rounded-table">
                    <thead>
                        <tr className="hospital-table">
                        <th>Chat History</th>
                        <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.map((row, index) => (
                        <tr key={index} >
                            <td>Chat {index +1}</td>
                
                            <div className="icon-container">
                                <Icon className="icon" onClick={()=> {
                                    socket.emit('join_chat', row.chatId)
                                    setChatId(row.chatId)
                                    setVisualizerModal(true)
                                    setInfoModal(row)
                                    }}>visibility</Icon>
                            </div>
                        </tr>
                        ))}
                    </tbody>
                </table>
                </div>                    

            </div>
            {visualizerModal && 
                <WrapperModal
                    onDismiss={cancelCreationHandler}
                >
                    <VisualizerModal row={infoModal}/>
                </WrapperModal>

            }
        </div>
    )  
};
export default NotificationChat;

